import GoodsItem from "./GoodsItem"

export default function GoodsList (props) {
  const { goods = [], addOrder = Function.prototype } = props;
  if (!goods.length) {
    return (
      <h1> Nothing found </h1>
    )
  }

  return (
    <div className='goods'>
      {goods.map(item => {
        return <GoodsItem key={item.id} {...item} addOrder={addOrder} />
      })}
    </div>
  )
}